// initialed state
export const DRAWER_MODES = {
	test: 'test',
	edit: 'edit',
	preview: 'preview',
	closed: null,
};

export const initialState = () => ({
	leftSideDrawerState: DRAWER_MODES.closed,
});

const state = initialState();

export default state;
